import moment from 'moment'
import dateType from '@/components/menus/ticket/enums/dateType'

const printDateDescription = (dateTypeParam, description) => {
  if (description === '合計') {
    return description
  }

  switch (dateTypeParam) {
    case dateType.DAILY:
      return moment(description, 'YYYYMMDD').format('YYYY年 MM月 DD日')
    case dateType.WEEKLY:
      let dateObject = moment(description, 'YYYYww').add(1, 'weeks').weekday(6)
      const firstWeek = moment(dateObject).date(1).weeks()

      if (description.substr(4, 2) === '52') {
        dateObject = moment(description, 'YYYY')
        return dateObject.format('YYYY年') + ` 12月 5週目`
      }

      if (description.substr(4, 2) === '53') {
        dateObject = moment(description, 'YYYY')
        return dateObject.format('YYYY年') + ` 12月 6週目`
      }

      if (description.substr(4, 2) === '00') {
        dateObject = moment(description, 'YYYY')
        return dateObject.format('YYYY年') + ` 01月 1週目`
      }

      return dateObject.format('YYYY年 MM月') + ` ${dateObject.weeks() - firstWeek + 1}週目`
    case dateType.MONTHLY:
      return moment(description, 'YYYYMM').format('YYYY年 MM月')
    case dateType.YEARLY:
      return moment(description, 'YYYYMM').format('YYYY年')
    default:
      return description
  }
}

const numberStringFormat = (number) => {
  return `${number < 10 ? '0' : ''}${number}`
}

const getSearchPeriodConditions = (dateTypeParam, startFormat, endFormat) => {
  switch (dateTypeParam) {
    case dateType.DAILY:
      return {start: startFormat.date.replace(/-/gi, ''), end: endFormat.date.replace(/-/gi, '')}
    case dateType.WEEKLY:
      const startWeekFormat = moment(startFormat.month).year() + numberStringFormat(startFormat.week)
      const endWeekFormat = moment(endFormat.month).year() + numberStringFormat(endFormat.week)
      return {start: startWeekFormat, end: endWeekFormat}
    case dateType.MONTHLY:
      return {start: moment(startFormat.month).format('YYYYMM'), end: moment(endFormat.month).format('YYYYMM')}
    case dateType.QUARTER:
      const startQuarterFormat = startFormat.year.substr(0, 4) + numberStringFormat(startFormat.quarter.substr(0, 1) * 3 - 2)
      const endQuarterFormat = endFormat.year.substr(0, 4) + numberStringFormat(endFormat.quarter.substr(0, 1) * 3)
      return {start: startQuarterFormat, end: endQuarterFormat}
    case dateType.HALF:
      const startHalfFormat = startFormat.year.substr(0, 4) + (startFormat.half === '上半期' ? '01' : '07')
      const endHalfFormat = endFormat.year.substr(0, 4) + (endFormat.half === '上半期' ? '06' : '12')
      return {start: startHalfFormat, end: endHalfFormat}
    case dateType.YEARLY:
      return {start: startFormat.year.substr(0, 4), end: endFormat.year.substr(0, 4)}
  }
}

const setWeekSelects = (month) => {
  const monthStartWeeks = moment(month).date(1).week()
  const monthEndWeeksObject = moment(month).date(1).add(1, 'months').subtract(1, 'days')
  const monthEndWeeks = monthEndWeeksObject.month() === 11
    ? moment(month).date(1).add(1, 'months').subtract(1, 'days').subtract(1, 'weeks').week() + 1
    : moment(month).date(1).add(1, 'months').subtract(1, 'days').week()
  const weekCount = monthEndWeeks - monthStartWeeks
  const weekSelects = []

  for (let i = 0; i <= weekCount; i++) {
    weekSelects.push({displayed: `${i + 1}週目`, realWeeks: (monthStartWeeks + i - 1)})
  }
  return weekSelects
}

const setYearSelects = () => {
  const years = []
  const mmt = moment().add(1, 'year')
  let subtractYears = 5
  while (subtractYears-- > 0) {
    years.push(mmt.subtract(1, 'year').format('YYYY年'))
  }

  return years
}

export default {
  printDateDescription,
  getSearchPeriodConditions,
  setWeekSelects,
  setYearSelects
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/util/statistics_date_util.js